import { render, staticRenderFns } from "./PhoneVoiceMails.vue?vue&type=template&id=5cc8aadc&scoped=true&"
import script from "./PhoneVoiceMails.vue?vue&type=script&lang=js&"
export * from "./PhoneVoiceMails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc8aadc",
  null
  
)

/* custom blocks */
import block0 from "./PhoneVoiceMails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports